<template>
  <div class="status-icon">
    <svg
      width="42"
      height="42"
      viewBox="0 0 42 42"
      fill="none"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      class="status-icon_img"
      :class="{ 'status-icon_img__active': hover }"
    >
      <rect
        id="rect1"
        width="42"
        height="42"
        rx="8.53125"
        fill="#62f67a"
        x="0"
        y="0"
        style="stroke-width: 0.164062"
      />
      <path
        id="path1"
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="m 26.79551,11.77685 c 0,1.1663 -0.35536,2.2509 -0.96535,3.15453 h 5.32088 c 2.58448,0 4.67972,2.06303 4.67972,4.60781 0,2.16693 -1.51922,3.98458 -3.56606,4.47644 -0.357,0.0858 -0.72992,0.13125 -1.11366,0.13125 h -1.29577 l 8.20723,9.32187 H 25.72549 L 21,28.08127 16.27444,33.46875 H 3.9375 l 8.20728,-9.32187 H 10.8489 c -0.38371,0 -0.75663,-0.0454 -1.11351,-0.13125 -2.0469,-0.49186 -3.56608,-2.30951 -3.56608,-4.47644 0,-2.54478 2.09513,-4.60781 4.67959,-4.60781 h 5.32087 c -0.60992,-0.90363 -0.96526,-1.98823 -0.96526,-3.15453 0,-3.15164 2.59479,-5.70654 5.79549,-5.70654 3.2007,0 5.79551,2.5549 5.79551,5.70654 z"
        fill="#000000"
        style="stroke-width: 0.164062"
      />
      <path
        id="path2"
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="m 24.88779,11.77685 c 0,1.30881 -0.66708,2.46422 -1.68476,3.15453 -0.62623,0.42477 -1.38518,0.67344 -2.20303,0.67344 -0.81785,0 -1.57664,-0.24867 -2.20287,-0.67344 -1.01768,-0.69031 -1.68475,-1.84572 -1.68475,-3.15453 0,-2.11414 1.74053,-3.82799 3.88762,-3.82799 2.14709,0 3.88779,1.71385 3.88779,3.82799 z m 0.78865,10.49152 h 5.47476 c 1.53071,0 2.77167,-1.22194 2.77167,-2.72918 0,-1.50741 -1.24096,-2.72918 -2.77167,-2.72918 H 10.84894 c -1.53078,0 -2.77175,1.22177 -2.77175,2.72918 0,1.50724 1.24097,2.72918 2.77175,2.72918 h 5.47479 l -8.2073,9.32186 h 7.28492 L 21,25.20722 l 5.5988,6.38301 h 7.28486 z"
        fill="#ffffff"
        style="stroke-width: 0.164062"
      />
    </svg>

    <svg
      width="42"
      height="42"
      viewBox="0 0 42 42"
      fill="none"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      class="status-icon_img"
      :class="{ 'status-icon_img__active': !hover }"
    >
      <rect
        id="rect1"
        width="42"
        height="42"
        rx="8.53125"
        fill="#181818"
        x="0"
        y="0"
        style="stroke-width: 0.164062"
      />
      <path
        id="path1"
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="m 26.79551,11.77685 c 0,1.1663 -0.35536,2.2509 -0.96535,3.15453 h 5.32088 c 2.58448,0 4.67972,2.06303 4.67972,4.60781 0,2.16693 -1.51922,3.98458 -3.56606,4.47644 -0.357,0.0858 -0.72992,0.13125 -1.11366,0.13125 h -1.29577 l 8.20723,9.32187 H 25.72549 L 21,28.08127 16.27444,33.46875 H 3.9375 l 8.20728,-9.32187 H 10.8489 c -0.38371,0 -0.75663,-0.0454 -1.11351,-0.13125 -2.0469,-0.49186 -3.56608,-2.30951 -3.56608,-4.47644 0,-2.54478 2.09513,-4.60781 4.67959,-4.60781 h 5.32087 c -0.60992,-0.90363 -0.96526,-1.98823 -0.96526,-3.15453 0,-3.15164 2.59479,-5.70654 5.79549,-5.70654 3.2007,0 5.79551,2.5549 5.79551,5.70654 z"
        fill="#454545"
        style="stroke-width: 0.164062"
      />
      <path
        id="path2"
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="m 24.88779,11.77685 c 0,1.30881 -0.66708,2.46422 -1.68476,3.15453 -0.62623,0.42477 -1.38518,0.67344 -2.20303,0.67344 -0.81785,0 -1.57664,-0.24867 -2.20287,-0.67344 -1.01768,-0.69031 -1.68475,-1.84572 -1.68475,-3.15453 0,-2.11414 1.74053,-3.82799 3.88762,-3.82799 2.14709,0 3.88779,1.71385 3.88779,3.82799 z m 0.78865,10.49152 h 5.47476 c 1.53071,0 2.77167,-1.22194 2.77167,-2.72918 0,-1.50741 -1.24096,-2.72918 -2.77167,-2.72918 H 10.84894 c -1.53078,0 -2.77175,1.22177 -2.77175,2.72918 0,1.50724 1.24097,2.72918 2.77175,2.72918 h 5.47479 l -8.2073,9.32186 h 7.28492 L 21,25.20722 l 5.5988,6.38301 h 7.28486 z"
        fill="#181818"
        style="stroke-width: 0.164062"
      />
    </svg>
  </div>
</template>

<script>
  export default {
    name: 'StatusIconKuper',
    props: {
      hover: {
        type: Boolean,
        default: false,
      },
    },
  }
</script>

<style scoped lang="less">
.status-icon {
  position: relative;
  width: 33px;
  height: 33px;

  .media-xl({
    width: 42px;
    height: 42px;
  });

  &_img {
    position: absolute;
    left: 0;
    right: 0;
    bottom: 0;
    top: 0;
    transition: opacity 0.3s ease;
    opacity: 0;
    max-width: 100%;

    &__active {
      opacity: 1;
    }
  }
}
</style>
